<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="step" v-if="$store.state.formStep === 1">
                <div class="question tw-mt-1">Quantos litros/mês gasta <br class="lg:tw-hidden">a frota da sua empresa?</div>
                <div class="choices tw-pb-3">
                    <div class="choice" @click="mpg = 'MENOS_3000';" :class="{ 'active' : mpg == 'MENOS_3000' }">
                        <svg id="Group_1978" data-name="Group 1978" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46.266" height="46.131" viewBox="0 0 46.266 46.131">
                            <defs>
                              <clipPath id="clip-path">
                                <rect id="Rectangle_85" data-name="Rectangle 85" width="46.266" height="46.131" fill="none"/>
                              </clipPath>
                            </defs>
                            <g id="Group_1977" data-name="Group 1977" clip-path="url(#clip-path)">
                              <path id="Path_82" data-name="Path 82" d="M.986,4.5,13.322,8.133a2.9,2.9,0,0,1,1.045.558l3.751,3.125,3.157-3.387L16.09,4.217a1.268,1.268,0,0,0-.442-.233L2.3.052A1.271,1.271,0,0,0,.717.912l-.59,2.01A1.271,1.271,0,0,0,.986,4.5" transform="translate(-0.054 0)" fill="#00b3cd"/>
                              <path id="Path_83" data-name="Path 83" d="M68.052,36.557a.825.825,0,0,1,.282.478l5.74,29.833a3.366,3.366,0,0,0,4.664,2.444l8.583-3.792a.826.826,0,0,1,1.1.443,1.1,1.1,0,0,0,1.438.6l4.182-1.716a1.1,1.1,0,0,0,.6-1.437L86.835,44.366a.825.825,0,0,1,.141-.854l.9-1.036a1.271,1.271,0,0,0-.129-1.791l-8.71-7.547a1.272,1.272,0,0,0-1.793.133L75.3,35.514a.826.826,0,0,1-1.156.094l-3.19-2.658L67.79,36.344Zm10.572,30.1a1.875,1.875,0,0,1-2.609-1.433l-1.933-12.77a3.944,3.944,0,0,1,.611-2.774l2.153,1.7a5.41,5.41,0,0,1,1.81,2.57l3.717,11.049ZM77.3,47.957l1.239-.222A3.991,3.991,0,0,1,83,50.378l3.965,11.779a.825.825,0,0,1-.449,1.02l-2.623,1.159-3.67-10.9a7.035,7.035,0,0,0-2.359-3.348l-1.991-1.577a3.991,3.991,0,0,1,1.433-.555Zm-4.5-5.79,1.17,4.956a.826.826,0,0,1-.615.991.792.792,0,0,1-.19.022.825.825,0,0,1-.8-.636l-1.17-4.956a.827.827,0,1,1,1.609-.38ZM70.487,37.22a.826.826,0,0,1,1,.6l.413,1.618a.826.826,0,0,1-.6,1,.8.8,0,0,1-.205.026.825.825,0,0,1-.8-.621l-.411-1.616a.826.826,0,0,1,.6-1.007Z" transform="translate(-48.458 -23.467)" fill="#00b3cd"/>
                              <path id="Path_84" data-name="Path 84" d="M4.133,57.939a3.995,3.995,0,0,0,4.13-4.13c0-1.911-2.674-6.166-4.13-7.847C2.678,47.642,0,51.9,0,53.809a3.994,3.994,0,0,0,4.13,4.13" transform="translate(0 -32.855)" fill="#2c3c53"/>
                            </g>
                        </svg>
                        <p class="lg:tw-text-left"><b>Menos de <br>3000 litros/mês</b></p>
                    </div>
                    <div class="choice" @click="mpg = 'MAIS_3000';" :class="{ 'active' : mpg == 'MAIS_3000' }">
                        <svg id="Group_1978" data-name="Group 1978" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46.266" height="46.131" viewBox="0 0 46.266 46.131">
                            <defs>
                              <clipPath id="clip-path">
                                <rect id="Rectangle_85" data-name="Rectangle 85" width="46.266" height="46.131" fill="none"/>
                              </clipPath>
                            </defs>
                            <g id="Group_1977" data-name="Group 1977" clip-path="url(#clip-path)">
                              <path id="Path_82" data-name="Path 82" d="M.986,4.5,13.322,8.133a2.9,2.9,0,0,1,1.045.558l3.751,3.125,3.157-3.387L16.09,4.217a1.268,1.268,0,0,0-.442-.233L2.3.052A1.271,1.271,0,0,0,.717.912l-.59,2.01A1.271,1.271,0,0,0,.986,4.5" transform="translate(-0.054 0)" fill="#00b3cd"/>
                              <path id="Path_83" data-name="Path 83" d="M68.052,36.557a.825.825,0,0,1,.282.478l5.74,29.833a3.366,3.366,0,0,0,4.664,2.444l8.583-3.792a.826.826,0,0,1,1.1.443,1.1,1.1,0,0,0,1.438.6l4.182-1.716a1.1,1.1,0,0,0,.6-1.437L86.835,44.366a.825.825,0,0,1,.141-.854l.9-1.036a1.271,1.271,0,0,0-.129-1.791l-8.71-7.547a1.272,1.272,0,0,0-1.793.133L75.3,35.514a.826.826,0,0,1-1.156.094l-3.19-2.658L67.79,36.344Zm10.572,30.1a1.875,1.875,0,0,1-2.609-1.433l-1.933-12.77a3.944,3.944,0,0,1,.611-2.774l2.153,1.7a5.41,5.41,0,0,1,1.81,2.57l3.717,11.049ZM77.3,47.957l1.239-.222A3.991,3.991,0,0,1,83,50.378l3.965,11.779a.825.825,0,0,1-.449,1.02l-2.623,1.159-3.67-10.9a7.035,7.035,0,0,0-2.359-3.348l-1.991-1.577a3.991,3.991,0,0,1,1.433-.555Zm-4.5-5.79,1.17,4.956a.826.826,0,0,1-.615.991.792.792,0,0,1-.19.022.825.825,0,0,1-.8-.636l-1.17-4.956a.827.827,0,1,1,1.609-.38ZM70.487,37.22a.826.826,0,0,1,1,.6l.413,1.618a.826.826,0,0,1-.6,1,.8.8,0,0,1-.205.026.825.825,0,0,1-.8-.621l-.411-1.616a.826.826,0,0,1,.6-1.007Z" transform="translate(-48.458 -23.467)" fill="#00b3cd"/>
                              <path id="Path_84" data-name="Path 84" d="M4.133,57.939a3.995,3.995,0,0,0,4.13-4.13c0-1.911-2.674-6.166-4.13-7.847C2.678,47.642,0,51.9,0,53.809a3.994,3.994,0,0,0,4.13,4.13" transform="translate(0 -32.855)" fill="#2c3c53"/>
                            </g>
                        </svg>
                        <p class="lg:tw-text-left"><b>Mais de <br>a 3000 litros/mês</b></p>
                    </div>
                </div>
                <button class="choose lg:tw-mt-2" @click="$store.state.formStep++;" :class="{ 'disabled' : !mpg }">Escolher</button>
            </div>
            <div class="step" v-if="$store.state.formStep === 2">
                <div class="question tw-mt-1">Nº de veículos da sua empresa?</div>
                <div class="choices tw-pb-3">
                    <div class="choice vehicle" @click="vehicles = '1';" :class="{ 'active' : vehicles == '1' }">
                        <svg id="_008-delivery-truck-silhouette" data-name="008-delivery-truck-silhouette" xmlns="http://www.w3.org/2000/svg" width="65.468" height="53.346" viewBox="0 0 65.468 53.346">
                          <path id="Path_81" data-name="Path 81" d="M.719,46.4a2.333,2.333,0,0,1,1.7-.72h38.8A2.458,2.458,0,0,1,43.645,48.1v7.274h6.062a6.583,6.583,0,0,1,4.13,1.7l7.5,7.5a5.159,5.159,0,0,1,.852,1.137,6.9,6.9,0,0,1,.53,1.155,6.283,6.283,0,0,1,.246,1.4q.075.891.095,1.308t0,1.44q-.019,1.024-.019,1.326V84.473A2.459,2.459,0,0,1,65.468,86.9a3.047,3.047,0,0,1-.151,1,1.435,1.435,0,0,1-.512.7q-.36.266-.625.436a2.091,2.091,0,0,1-.891.227l-.852.076q-.228.018-.966,0t-.853-.019H58.194a9.7,9.7,0,0,1-9.7,9.7,9.7,9.7,0,0,1-9.7-9.7H24.247a9.347,9.347,0,0,1-2.841,6.857,9.344,9.344,0,0,1-6.857,2.842A9.344,9.344,0,0,1,7.691,96.18,9.344,9.344,0,0,1,4.85,89.323q-.113,0-.852.019t-.966,0l-.853-.076a2.087,2.087,0,0,1-.89-.227q-.266-.17-.625-.436a1.433,1.433,0,0,1-.512-.7A3.02,3.02,0,0,1,0,86.9V48.1A2.332,2.332,0,0,1,.719,46.4ZM45.086,92.733a4.757,4.757,0,1,0-1.44-3.41A4.661,4.661,0,0,0,45.086,92.733Zm-1.44-22.808H58.194V68.788a1.134,1.134,0,0,0-.341-.834l-7.388-7.388a1.134,1.134,0,0,0-.834-.341H43.646ZM11.139,92.733a4.757,4.757,0,0,0,6.82,0,4.758,4.758,0,0,0,0-6.82,4.759,4.759,0,0,0-6.82,0,4.757,4.757,0,0,0,0,6.82Z" transform="translate(0 -45.676)" fill="#0095b1"/>
                        </svg>
                        <p class="lg:tw-text-center"><b>1 veículo</b></p>
                    </div>
                    <div class="choice vehicle" @click="vehicles = '2_5';" :class="{ 'active' : vehicles == '2_5' }">
                        <svg id="_008-delivery-truck-silhouette" data-name="008-delivery-truck-silhouette" xmlns="http://www.w3.org/2000/svg" width="65.468" height="53.346" viewBox="0 0 65.468 53.346">
                          <path id="Path_81" data-name="Path 81" d="M.719,46.4a2.333,2.333,0,0,1,1.7-.72h38.8A2.458,2.458,0,0,1,43.645,48.1v7.274h6.062a6.583,6.583,0,0,1,4.13,1.7l7.5,7.5a5.159,5.159,0,0,1,.852,1.137,6.9,6.9,0,0,1,.53,1.155,6.283,6.283,0,0,1,.246,1.4q.075.891.095,1.308t0,1.44q-.019,1.024-.019,1.326V84.473A2.459,2.459,0,0,1,65.468,86.9a3.047,3.047,0,0,1-.151,1,1.435,1.435,0,0,1-.512.7q-.36.266-.625.436a2.091,2.091,0,0,1-.891.227l-.852.076q-.228.018-.966,0t-.853-.019H58.194a9.7,9.7,0,0,1-9.7,9.7,9.7,9.7,0,0,1-9.7-9.7H24.247a9.347,9.347,0,0,1-2.841,6.857,9.344,9.344,0,0,1-6.857,2.842A9.344,9.344,0,0,1,7.691,96.18,9.344,9.344,0,0,1,4.85,89.323q-.113,0-.852.019t-.966,0l-.853-.076a2.087,2.087,0,0,1-.89-.227q-.266-.17-.625-.436a1.433,1.433,0,0,1-.512-.7A3.02,3.02,0,0,1,0,86.9V48.1A2.332,2.332,0,0,1,.719,46.4ZM45.086,92.733a4.757,4.757,0,1,0-1.44-3.41A4.661,4.661,0,0,0,45.086,92.733Zm-1.44-22.808H58.194V68.788a1.134,1.134,0,0,0-.341-.834l-7.388-7.388a1.134,1.134,0,0,0-.834-.341H43.646ZM11.139,92.733a4.757,4.757,0,0,0,6.82,0,4.758,4.758,0,0,0,0-6.82,4.759,4.759,0,0,0-6.82,0,4.757,4.757,0,0,0,0,6.82Z" transform="translate(0 -45.676)" fill="#0095b1"/>
                        </svg>
                        <p class="lg:tw-text-center"><b>2 - 5 veículos</b></p>
                    </div>
                    <div class="choice vehicle" @click="vehicles = '6_10';" :class="{ 'active' : vehicles == '6_10' }">
                        <svg id="_008-delivery-truck-silhouette" data-name="008-delivery-truck-silhouette" xmlns="http://www.w3.org/2000/svg" width="65.468" height="53.346" viewBox="0 0 65.468 53.346">
                          <path id="Path_81" data-name="Path 81" d="M.719,46.4a2.333,2.333,0,0,1,1.7-.72h38.8A2.458,2.458,0,0,1,43.645,48.1v7.274h6.062a6.583,6.583,0,0,1,4.13,1.7l7.5,7.5a5.159,5.159,0,0,1,.852,1.137,6.9,6.9,0,0,1,.53,1.155,6.283,6.283,0,0,1,.246,1.4q.075.891.095,1.308t0,1.44q-.019,1.024-.019,1.326V84.473A2.459,2.459,0,0,1,65.468,86.9a3.047,3.047,0,0,1-.151,1,1.435,1.435,0,0,1-.512.7q-.36.266-.625.436a2.091,2.091,0,0,1-.891.227l-.852.076q-.228.018-.966,0t-.853-.019H58.194a9.7,9.7,0,0,1-9.7,9.7,9.7,9.7,0,0,1-9.7-9.7H24.247a9.347,9.347,0,0,1-2.841,6.857,9.344,9.344,0,0,1-6.857,2.842A9.344,9.344,0,0,1,7.691,96.18,9.344,9.344,0,0,1,4.85,89.323q-.113,0-.852.019t-.966,0l-.853-.076a2.087,2.087,0,0,1-.89-.227q-.266-.17-.625-.436a1.433,1.433,0,0,1-.512-.7A3.02,3.02,0,0,1,0,86.9V48.1A2.332,2.332,0,0,1,.719,46.4ZM45.086,92.733a4.757,4.757,0,1,0-1.44-3.41A4.661,4.661,0,0,0,45.086,92.733Zm-1.44-22.808H58.194V68.788a1.134,1.134,0,0,0-.341-.834l-7.388-7.388a1.134,1.134,0,0,0-.834-.341H43.646ZM11.139,92.733a4.757,4.757,0,0,0,6.82,0,4.758,4.758,0,0,0,0-6.82,4.759,4.759,0,0,0-6.82,0,4.757,4.757,0,0,0,0,6.82Z" transform="translate(0 -45.676)" fill="#0095b1"/>
                        </svg>
                        <p class="lg:tw-text-center"><b>6 - 10 veículos</b></p>
                    </div>
                    <div class="choice vehicle" @click="vehicles = '+11';" :class="{ 'active' : vehicles == '+11' }">
                        <svg id="_008-delivery-truck-silhouette" data-name="008-delivery-truck-silhouette" xmlns="http://www.w3.org/2000/svg" width="65.468" height="53.346" viewBox="0 0 65.468 53.346">
                          <path id="Path_81" data-name="Path 81" d="M.719,46.4a2.333,2.333,0,0,1,1.7-.72h38.8A2.458,2.458,0,0,1,43.645,48.1v7.274h6.062a6.583,6.583,0,0,1,4.13,1.7l7.5,7.5a5.159,5.159,0,0,1,.852,1.137,6.9,6.9,0,0,1,.53,1.155,6.283,6.283,0,0,1,.246,1.4q.075.891.095,1.308t0,1.44q-.019,1.024-.019,1.326V84.473A2.459,2.459,0,0,1,65.468,86.9a3.047,3.047,0,0,1-.151,1,1.435,1.435,0,0,1-.512.7q-.36.266-.625.436a2.091,2.091,0,0,1-.891.227l-.852.076q-.228.018-.966,0t-.853-.019H58.194a9.7,9.7,0,0,1-9.7,9.7,9.7,9.7,0,0,1-9.7-9.7H24.247a9.347,9.347,0,0,1-2.841,6.857,9.344,9.344,0,0,1-6.857,2.842A9.344,9.344,0,0,1,7.691,96.18,9.344,9.344,0,0,1,4.85,89.323q-.113,0-.852.019t-.966,0l-.853-.076a2.087,2.087,0,0,1-.89-.227q-.266-.17-.625-.436a1.433,1.433,0,0,1-.512-.7A3.02,3.02,0,0,1,0,86.9V48.1A2.332,2.332,0,0,1,.719,46.4ZM45.086,92.733a4.757,4.757,0,1,0-1.44-3.41A4.661,4.661,0,0,0,45.086,92.733Zm-1.44-22.808H58.194V68.788a1.134,1.134,0,0,0-.341-.834l-7.388-7.388a1.134,1.134,0,0,0-.834-.341H43.646ZM11.139,92.733a4.757,4.757,0,0,0,6.82,0,4.758,4.758,0,0,0,0-6.82,4.759,4.759,0,0,0-6.82,0,4.757,4.757,0,0,0,0,6.82Z" transform="translate(0 -45.676)" fill="#0095b1"/>
                        </svg>
                        <p class="lg:tw-text-center"><b>+ 10 veículos</b></p>
                    </div>
                </div>
                <button class="choose" @click="$store.state.formStep++;" :class="{ 'disabled' : !vehicles }">Escolher</button>
            </div>
            <div class="step" v-if="$store.state.formStep === 3">
                <div class="question tw-mt-1">Para receber a simulação <br class="tw-block lg:tw-hidden">preencha os dados</div>
                <fieldset class="tw-px-6 lg:tw-px-0 xl:tw-px-0 tw-pb-3">
                    <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <input type="text"
                                id="input-fullName"
                                placeholder=" "
                                v-model="fullName"
                            >
                            <label>
                                Nome e apelido
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                        <div class="input-group input-group-email" :class="classes">
                            <input type="email"
                                id="input-email"
                                placeholder=" "
                                v-model.lazy="email"
                            >
                            <label>
                                Email {{ errors [0]}}
                            </label>
                        </div>
                    </validation-provider>
                    <div class="tw-flex tw-flex-col tw-gap-0 lg:tw-flex-row lg:tw-gap-2">
                        <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes }">
                            <div class="input-group input-group-phone" :class="classes">
                                <input type="tel"
                                    id="input-phone"
                                    placeholder=" "
                                    v-model="phone"
                                    v-mask="{mask: '999999999', placeholder:' '}"
                                >
                                <label>
                                    Telefone
                                </label>
                            </div>
                        </validation-provider>
                        <validation-provider class="tw-w-full tw-w-block" name="city" rules="required" v-slot="{ classes }">
                            <div class="input-group input-group-city" :class="classes">
                                <select id="input-city" v-model="city">
                                    <option disabled selected value=""></option>
                                    <option>Abrantes</option>
                                    <option>Águeda</option>
                                    <option>Aguiar da Beira</option>
                                    <option>Alandroal</option>
                                    <option>Albergaria-a-Velha</option>
                                    <option>Albufeira</option>
                                    <option>Alcácer do Sal</option>
                                    <option>Alcanena</option>
                                    <option>Alcobaça</option>
                                    <option>Alcochete</option>
                                    <option>Alcoutim</option>
                                    <option>Alenquer</option>
                                    <option>Alfândega da Fé</option>
                                    <option>Alijó</option>
                                    <option>Aljezur</option>
                                    <option>Aljustrel</option>
                                    <option>Almada</option>
                                    <option>Almeida</option>
                                    <option>Almeirim</option>
                                    <option>Almodôvar</option>
                                    <option>Alpiarça</option>
                                    <option>Alter do Chão</option>
                                    <option>Alvaiázere</option>
                                    <option>Alvito</option>
                                    <option>Amadora</option>
                                    <option>Amarante</option>
                                    <option>Amares</option>
                                    <option>Anadia</option>
                                    <option>Angra do Heroísmo</option>
                                    <option>Ansião</option>
                                    <option>Arcos de Valdevez</option>
                                    <option>Arganil</option>
                                    <option>Armamar</option>
                                    <option>Arouca</option>
                                    <option>Arraiolos</option>
                                    <option>Arronches</option>
                                    <option>Arruda dos Vinhos</option>
                                    <option>Aveiro</option>
                                    <option>Avis</option>
                                    <option>Azambuja</option>
                                    <option>Baião</option>
                                    <option>Barcelos</option>
                                    <option>Barrancos</option>
                                    <option>Barreiro</option>
                                    <option>Batalha</option>
                                    <option>Beja</option>
                                    <option>Belmonte</option>
                                    <option>Benavente</option>
                                    <option>Bombarral</option>
                                    <option>Borba</option>
                                    <option>Boticas</option>
                                    <option>Braga</option>
                                    <option>Bragança</option>
                                    <option>Cabeceiras de Basto</option>
                                    <option>Cadaval</option>
                                    <option>Caldas da Rainha</option>
                                    <option>Calheta de S.Jorge (Açores)</option>
                                    <option>Calheta (Madeira)</option>
                                    <option>Câmara de Lobos (Madeira)</option>
                                    <option>Caminha</option>
                                    <option>Campo Maior</option>
                                    <option>Cantanhede</option>
                                    <option>Carrazeda de Ansiães</option>
                                    <option>Carregal do Sal</option>
                                    <option>Cartaxo</option>
                                    <option>Cascais</option>
                                    <option>Castanheira de Pêra</option>
                                    <option>Castelo Branco</option>
                                    <option>Castelo de Paiva</option>
                                    <option>Castelo de Vide</option>
                                    <option>Castro Daire</option>
                                    <option>Castro Marim</option>
                                    <option>Castro Verde</option>
                                    <option>Celorico da Beira</option>
                                    <option>Celorico de Basto</option>
                                    <option>Chamusca</option>
                                    <option>Chaves</option>
                                    <option>Cinfães</option>
                                    <option>Coimbra</option>
                                    <option>Condeixa-a-Nova</option>
                                    <option>Constância</option>
                                    <option>Coruche</option>
                                    <option>Corvo (Açores)</option>
                                    <option>Covilhã</option>
                                    <option>Crato</option>
                                    <option>Cuba</option>
                                    <option>Elvas</option>
                                    <option>Entroncamento</option>
                                    <option>Espinho</option>
                                    <option>Esposende</option>
                                    <option>Estarreja</option>
                                    <option>Estremoz</option>
                                    <option>Évora</option>
                                    <option>Fafe</option>
                                    <option>Faro</option>
                                    <option>Felgueiras</option>
                                    <option>Ferreira do Alentejo</option>
                                    <option>Ferreira do Zêzere</option>
                                    <option>Figueira da Foz</option>
                                    <option>Figueira de Castelo Rodrigo</option>
                                    <option>Figueiró dos Vinhos</option>
                                    <option>Fornos de Algodres</option>
                                    <option>Freixo de Espada à Cinta</option>
                                    <option>Fronteira</option>
                                    <option>Funchal (Madeira)</option>
                                    <option>Fundão</option>
                                    <option>Gavião</option>
                                    <option>Góis</option>
                                    <option>Golegã</option>
                                    <option>Gondomar</option>
                                    <option>Gouveia</option>
                                    <option>Grândola</option>
                                    <option>Guarda</option>
                                    <option>Guimarães</option>
                                    <option>Horta (Açores)</option>
                                    <option>Idanha-a-Nova</option>
                                    <option>Ílhavo</option>
                                    <option>Lagoa</option>
                                    <option>Lagoa (Açores)</option>
                                    <option>Lagos</option>
                                    <option>Lajes das Flores (Açores)</option>
                                    <option>Lajes do Pico (Açores)</option>
                                    <option>Lamego</option>
                                    <option>Leiria</option>
                                    <option>Lisboa</option>
                                    <option>Loulé</option>
                                    <option>Loures</option>
                                    <option>Lourinhã</option>
                                    <option>Lousã</option>
                                    <option>Lousada</option>
                                    <option>Mação</option>
                                    <option>Macedo de Cavaleiros</option>
                                    <option>Machico (Madeira)</option>
                                    <option>Madalena (Açores)</option>
                                    <option>Mafra</option>
                                    <option>Maia</option>
                                    <option>Mangualde</option>
                                    <option>Manteigas</option>
                                    <option>Marco de Canaveses</option>
                                    <option>Marinha Grande</option>
                                    <option>Marvão</option>
                                    <option>Matosinhos</option>
                                    <option>Mealhada</option>
                                    <option>Mêda</option>
                                    <option>Melgaço</option>
                                    <option>Mértola</option>
                                    <option>Mesão Frio</option>
                                    <option>Mira</option>
                                    <option>Miranda do Corvo</option>
                                    <option>Miranda do Douro</option>
                                    <option>Mirandela</option>
                                    <option>Mogadouro</option>
                                    <option>Moimenta da Beira</option>
                                    <option>Moita</option>
                                    <option>Monção</option>
                                    <option>Monchique</option>
                                    <option>Mondim de Basto</option>
                                    <option>Monforte</option>
                                    <option>Montalegre</option>
                                    <option>Montemor-o-Novo</option>
                                    <option>Montemor-o-Velho</option>
                                    <option>Montijo</option>
                                    <option>Mora</option>
                                    <option>Mortágua</option>
                                    <option>Moura</option>
                                    <option>Mourão</option>
                                    <option>Murça</option>
                                    <option>Murtosa</option>
                                    <option>Nazaré</option>
                                    <option>Nelas</option>
                                    <option>Nisa</option>
                                    <option>Nordeste (Açores)</option>
                                    <option>Óbidos</option>
                                    <option>Odemira</option>
                                    <option>Ooptionelas</option>
                                    <option>Oeiras</option>
                                    <option>Oleiros</option>
                                    <option>Olhão</option>
                                    <option>Oliveira de Azeméis</option>
                                    <option>Oliveira de Frades</option>
                                    <option>Oliveira do Bairro</option>
                                    <option>Oliveira do Hospital</option>
                                    <option>Ourém</option>
                                    <option>Ourique</option>
                                    <option>Ovar</option>
                                    <option>Paços de Ferreira</option>
                                    <option>Palmela</option>
                                    <option>Pampilhosa da Serra</option>
                                    <option>Paredes</option>
                                    <option>Paredes de Coura</option>
                                    <option>Pedrógão Grande</option>
                                    <option>Penacova</option>
                                    <option>Penafiel</option>
                                    <option>Penalva do Castelo</option>
                                    <option>Penamacor</option>
                                    <option>Penedono</option>
                                    <option>Penela</option>
                                    <option>Peniche</option>
                                    <option>Peso da Régua</option>
                                    <option>Pinhel</option>
                                    <option>Pombal</option>
                                    <option>Ponta Delgada (Açores)</option>
                                    <option>Ponta do Sol (Madeira)</option>
                                    <option>Ponte da Barca</option>
                                    <option>Ponte de Lima</option>
                                    <option>Ponte de Sor</option>
                                    <option>Portalegre</option>
                                    <option>Portel</option>
                                    <option>Portimão</option>
                                    <option>Porto</option>
                                    <option>Porto de Mós</option>
                                    <option>Porto Moniz (Madeira)</option>
                                    <option>Porto Santo (Madeira)</option>
                                    <option>Povoação (Açores)</option>
                                    <option>Póvoa de Lanhoso</option>
                                    <option>Póvoa de Varzim</option>
                                    <option>Praia da Vitória</option>
                                    <option>Proença-a-Nova</option>
                                    <option>Redondo</option>
                                    <option>Reguengos de Monsaraz</option>
                                    <option>Resende</option>
                                    <option>Ribeira Brava (Madeira)</option>
                                    <option>Ribeira de Pena</option>
                                    <option>Ribeira Grande (Açores)</option>
                                    <option>Rio Maior</option>
                                    <option>Sabrosa</option>
                                    <option>Sabugal</option>
                                    <option>Salvaterra de Magos</option>
                                    <option>Santa Comba Dão</option>
                                    <option>Santa Cruz da Graciosa (Açores)</option>
                                    <option>Santa Cruz das Flores (Açores)</option>
                                    <option>Santa Cruz (Madeira)</option>
                                    <option>Santa Maria da Feira</option>
                                    <option>Santa Marta de Penaguião</option>
                                    <option>Santana (Madeira)</option>
                                    <option>Santarém</option>
                                    <option>Santiago do Cacém</option>
                                    <option>Santo Tirso</option>
                                    <option>São Brás de Alportel</option>
                                    <option>São João da Madeira</option>
                                    <option>São João da Pesqueira</option>
                                    <option>São Pedro do Sul</option>
                                    <option>São Roque do Pico (Açores)</option>
                                    <option>São Vicente (Madeira)</option>
                                    <option>Sardoal</option>
                                    <option>Sátão</option>
                                    <option>Seia</option>
                                    <option>Seixal</option>
                                    <option>Sernancelhe</option>
                                    <option>Serpa</option>
                                    <option>Sertã</option>
                                    <option>Sesimbra</option>
                                    <option>Setúbal</option>
                                    <option>Sever do Vouga</option>
                                    <option>Silves</option>
                                    <option>Sines</option>
                                    <option>Sintra</option>
                                    <option>Sobral de Monte Agraço</option>
                                    <option>Soure</option>
                                    <option>Sousel</option>
                                    <option>Tábua</option>
                                    <option>Tabuaço</option>
                                    <option>Tarouca</option>
                                    <option>Tavira</option>
                                    <option>Terras de Bouro</option>
                                    <option>Tomar</option>
                                    <option>Tondela</option>
                                    <option>Torre de Moncorvo</option>
                                    <option>Torres Novas</option>
                                    <option>Torres Vedras</option>
                                    <option>Trancoso</option>
                                    <option>Trofa</option>
                                    <option>Vagos</option>
                                    <option>Vale de Cambra</option>
                                    <option>Valença</option>
                                    <option>Valongo</option>
                                    <option>Valpaços</option>
                                    <option>Velas (Açores)</option>
                                    <option>Vendas Novas</option>
                                    <option>Viana do Alentejo</option>
                                    <option>Viana do Castelo</option>
                                    <option>Vidigueira</option>
                                    <option>Vieira do Minho</option>
                                    <option>Vila de Rei</option>
                                    <option>Vila do Bispo</option>
                                    <option>Vila do Conde</option>
                                    <option>Vila do Porto (Açores)</option>
                                    <option>Vila Flor</option>
                                    <option>Vila Franca de Xira</option>
                                    <option>Vila Franca do Campo (Açores)</option>
                                    <option>Vila Nova da Barquinha</option>
                                    <option>Vila Nova de Cerveira</option>
                                    <option>Vila Nova de Famalicão</option>
                                    <option>Vila Nova de Foz Côa</option>
                                    <option>Vila Nova de Gaia</option>
                                    <option>Vila Nova de Paiva</option>
                                    <option>Vila Nova de Poiares</option>
                                    <option>Vila Pouca de Aguiar</option>
                                    <option>Vila Real</option>
                                    <option>Vila Real de Santo António</option>
                                    <option>Vila Velha de Ródão</option>
                                    <option>Vila Verde</option>
                                    <option>Vila Viçosa</option>
                                    <option>Vimioso</option>
                                    <option>Vinhais</option>
                                    <option>Viseu</option>
                                    <option>Vizela</option>
                                    <option>Vouzela</option>
                                </select>
                                <label :class="{ 'select-placeholder' : !city }">
                                    Localidade
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <validation-provider class="tw-w-full tw-w-block" name="company" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-company" :class="classes">
                            <input type="text"
                                id="input-company"
                                placeholder=" "
                                v-model="formCompany"
                            >
                            <label>
                                Nome da Empresa
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="nif" rules="required|nif" v-slot="{ classes }">
                        <div class="input-group input-group-nif" :class="classes">
                            <input type="tel"
                                id="input-nif"
                                placeholder=" "
                                v-model="nif"
                                v-mask="{mask: '999999999', placeholder:' '}"
                            >
                            <label>
                                NIF da Empresa
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                        <div class="mb-2">
                            <div class="form-check p-0">
                                <label class="form-check-label" :class="classes">
                                    <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                    <span class="checkmark"></span>
                                    <span class="tw-text-center lg:tw-text-left">Autorizo a {{ company }} a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                                </label>
                            </div>
                        </div>
                    </validation-provider>
                    <div class="tw-text-center tw-mt-4">
                        <button
                            type="submit"
                            class="btn-cta tw-mx-auto"
                            id="submit"
                            :disabled="formLoading"
                        >
                            Simular
                        </button>
                    </div>
                </fieldset>
            </div>
            <div class="bullets">
                <div :class="{ 'active' : $store.state.formStep >= 1 }"></div>
                <div :class="{ 'active' : $store.state.formStep >= 2 }"></div>
                <div :class="{ 'active' : $store.state.formStep >= 3 }"></div>
            </div>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/nif';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            mpg: '',
            vehicles: '',
            city: '',
            formCompany: '',
            nif: '',

            step: 1,
            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            let cmpInfo = {
                vendor:{
                    consents: [],
                },
                tcString: '',
            };

            try{
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                cible: this.$route.query.cible,
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,
                mclic: process.env.VUE_APP_MCLIC,

                fullName: this.fullName.toUpperCase(),
                phone: this.phone,
                email: this.email.toUpperCase(),
                mpg: this.mpg.toUpperCase(),
                vehicles: this.vehicles.toUpperCase(),
                city: this.city.toUpperCase(),
                company: this.formCompany.toUpperCase(),
                nif: this.nif,

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
